module.exports = __webpack_public_path__ + "img/zendesk.2ffdbda5.jpg";